import type { RefObject } from "react";

import { toCsvRow } from "./csv";

export const createOnPageArrive = (
  buffer: Record<number, unknown[][]>,
  nextToWriteRef: { current: number },
  writeCsvRow: (csvRow: string) => Promise<void>,
  exportStateRef?: RefObject<{
    cancelRequested: boolean;
    writable?: FileSystemWritableFileStream;
  }>,
) => {
  return async () => {
    if (exportStateRef?.current.cancelRequested) {
      return;
    }
    while (buffer[nextToWriteRef.current]) {
      const csvRows = buffer[nextToWriteRef.current];
      if (csvRows && csvRows.length > 0) {
        await writeCsvRow(csvRows.map((r) => toCsvRow(r)).join("\n"));
      }
      delete buffer[nextToWriteRef.current];
      nextToWriteRef.current++;
    }
  };
};

export const initStreamingExport = async (
  headers: unknown[],
  suggestedName: string,
  buffer: Record<number, unknown[][]>,
  nextToWriteRef: { current: number },
  exportStateRef?: RefObject<{
    cancelRequested: boolean;
    writable?: FileSystemWritableFileStream;
  }>,
) => {
  const handle = await window.showSaveFilePicker({
    suggestedName,
  });
  const encoder = new TextEncoder();
  const writable = await handle.createWritable();
  if (exportStateRef) {
    exportStateRef.current.writable = writable;
  }
  const writeCsvRow = async (csvRow: string) => {
    await writable.write(encoder.encode(`${csvRow}\n`));
  };
  await writeCsvRow(toCsvRow(headers as unknown[]));
  const onPageArrive = createOnPageArrive(
    buffer,
    nextToWriteRef,
    writeCsvRow,
    exportStateRef,
  );
  return { writable, onPageArrive } as const;
};
